<template>
    <div>
        <div v-if="subChapters">
            <draggable v-model="subChapters" :options="{draggable: '.list-group-item'}"
                    class="list-group mt-4" @end="saveOrder">
                <router-link v-for="subChapter in subChapters"
                            :to="{name: 'synthesis-sub-chapter-edit', params: { subChapterId: subChapter.id}}"
                            class="list-group-item list-group-item-action dd-flex align-items-center"
                            :key="subChapter.id">
                    {{subChapter.name.text}}
                    <a href="#" class="ml-auto" v-confirm="{
                                html: true,
                                ok: dialog => remove(dialog, subChapter),
                                message: 'Bist du sicher, dass du das Unterkapitel <strong>'+subChapter.name.text+'</strong> löschen möchtest?'}"><i
                            class="fa fa-trash fa-fw"></i></a>
                </router-link>
            </draggable>

            <hr>
            <a href="#" class="btn btn-success" style="margin-top: auto;"
              @click.prevent="showCreateModal = true">Hinzufügen</a>

            <hr>
            <div class="admin-info">
              Falls nur ein Kapitel existiert, wird dieses nicht angezeigt. Zudem werden beim Kapitel und Unterkapitel der Beschreibungstext nicht angezeigt.
            </div>
            <b-modal ref="modal" v-model="showCreateModal" @ok="add">
                <h1 slot="modal-title">Unterkapitel hinzufügen</h1>
                <div class="form-group">
                    <label for="name">Name</label>
                    <input type="text" id="name" v-model="subChapterName" class="form-control">
                </div>
            </b-modal> 
          </div>
        <loading v-else></loading>
    </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      showCreateModal: false,
      subChapters: this.data.subChapters,
      subChapterName: ""
    };
  },
  watch: {
    data(newData) {
      this.subChapters = newData.subChapters;
    }
  },
  methods: {
    add() {
      let form = new FormData();
      form.append("create_sub_chapter[name]", this.subChapterName);
      form.append("create_sub_chapter[chapter]", this.data.id);
      form.set("create_sub_chapter[submit]", null);
      axios
        .post("/api/" + store.state.language + "/sub_chapter/create", form)
        .then(({ data }) => {
          this.subChapters.push(data.result);
          this.subChapterName = "";
        });
    },
    remove(dialog, subChapter) {
      axios
        .post(
          "/api/" +
            store.state.language +
            "/sub_chapter/" +
            subChapter.id +
            "/delete"
        )
        .then(({ data }) => {
          if (data.success) {
            this.subChapters.splice(this.subChapters.indexOf(subChapter), 1);
          }
        });
    },
    saveOrder() {
      const subChapterIds = this.subChapters.map(subChapter => subChapter.id);
      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" + store.state.language + "/sub_chapter/set_sub_chapter_order",
          {
            ids: subChapterIds
          }
        )
        .then(({ data }) => {
          store.commit("finishSavingProcess");
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          alert(
            "Beim Speichern der Sortier-Reihenfolge ist ein Fehler aufgetreten."
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/sub_chapter/List.vue